import Swiper, {Navigation} from 'swiper';

const projectSliders = Array.from(document.querySelectorAll('.j-project-available-slider'));

projectSliders.forEach((slider) => {
    let currentSlider = {};
    const sliderContent = slider.querySelector('.j-project-available-slider__content');
    const options = {
        modules          : [Navigation],
        loop             : false,
        speed            : 800,
        spaceBetween     : 0,
        slidesPerView    : 'auto',
        slidesOffsetAfter: 35,
        navigation       : {
            nextEl: slider.querySelector('.j-project-available-next'),
            prevEl: slider.querySelector('.j-project-available-prev')
        },
        breakpoints: {
            1280: {
                allowTouchMove: false
            }
        }
    };

    currentSlider = new Swiper(sliderContent, options);
    currentSlider.init();
});
